'use client'

import React from 'react'
import { LinkedData } from './linked-data'
import { useSiteContext } from '@dustin-web/microsite-components/src/hooks'

const LinkedDataClient = () => {
  const { siteUrl } = useSiteContext()
  return <LinkedData siteUrl={siteUrl} />
}

export default LinkedDataClient
